const { CUSTOM_PROPERTY_PREFIX } = require("./constants.cjs")

const wrapWithRgb = tokenName => {
  return `rgb(var(${CUSTOM_PROPERTY_PREFIX}${tokenName})/<alpha-value>)`
}
const getTailwindColorsFromTokens = (tokens, prefix = "") => {
  const result = {}
  const tokenEntries = Object.entries(tokens)
  tokenEntries.forEach(([name, config]) => {
    if (config.value) {
      result[name] = wrapWithRgb(`${prefix}${name}`)
    } else {
      result[name] = getTailwindColorsFromTokens(config, `${prefix}${name}-`)
    }
  })
  return result
}

module.exports = {
  getTailwindColorsFromTokens,
}
